<template>
  <div class="">
    <div class="row">
      <div class="col-md-6">
        <h1>
          <img src="@/assets/images/logo200white.png" />
          <small>
            <i
              v-if="refreshing"
              class="fas fa-sync fa-spin refresh-icon refresh-icon-ref"
            ></i>
            <i v-else class="fa fa-refresh refresh-icon" @click="refresh()"></i>
          </small>
        </h1>
      </div>
      <div class="col-md-6 d-flex align-items-end flex-column"></div>
    </div>
    <hr />
    <application-list />
  </div>
</template>
<script>
import ApplicationList from '../components/application/ApplicationList.vue'

export default {
  name: 'dbaccess',
  data: function () {
    return {
      refreshing: false
    }
  },
  computed: {
  },
  methods: {
    setType (type) {
      this.logType = type;
    },
    async refresh () {
      const start = new Date().getTime();
      this.refreshing = true;
      await this.$store.dispatch('fetchApplications');
      const end = new Date().getTime();
      const time = end - start;
      if (time < 1000) {
        setTimeout(() => { this.refreshing = false }, 1500);
      } else {
        this.refreshing = false;
      }
    }
  },
  components: {
    ApplicationList
  }
}
</script>

<style scoped>
.refresh-icon {
  margin-left: 20px;
  cursor: pointer;
}

.refresh-icon-ref {
  color: #c3151c;
}

.refresh-icon:hover {
  color: #c3151c;
}
</style>>
